import dayjs from "dayjs";
import { IPeriodoFeedback } from "types";

export type PresetPeriodo = "todo" | "30d" | "90d" | "mes" | "ano" | "custom";

/** Presets que viram um intervalo de datas fixo. */
export type PresetComDatas = Exclude<PresetPeriodo, "todo" | "custom">;

export const PRESETS_PERIODO: { value: PresetPeriodo; label: string }[] = [
  { value: "todo", label: "Todo o período" },
  { value: "30d", label: "Últimos 30 dias" },
  { value: "90d", label: "Últimos 90 dias" },
  { value: "mes", label: "Mês atual" },
  { value: "ano", label: "Ano atual" },
  { value: "custom", label: "Personalizado" },
];

export const PRESET_PADRAO: PresetPeriodo = "todo";

const FORMATO_API = "YYYY-MM-DD";

/**
 * Datas no formato AAAA-MM-DD, calculadas no horário local.
 * Não usar toISOString(): converte para UTC e pode mudar o dia.
 */
export const periodoDoPreset = (preset: PresetComDatas): IPeriodoFeedback => {
  const hoje = dayjs();
  const inicio = {
    "30d": hoje.subtract(29, "day"),
    "90d": hoje.subtract(89, "day"),
    mes: hoje.startOf("month"),
    ano: hoje.startOf("year"),
  }[preset];

  return {
    data_inicio: inicio.format(FORMATO_API),
    data_fim: hoje.format(FORMATO_API),
  };
};

const REGEX_DATA = /^\d{4}-\d{2}-\d{2}$/;

const dataValida = (valor: string) =>
  REGEX_DATA.test(valor) && dayjs(valor).format(FORMATO_API) === valor;

/** Devolve a mensagem de erro ou null se o período puder ser enviado à API. */
export const validarPeriodo = ({ data_inicio, data_fim }: IPeriodoFeedback) => {
  if (!data_inicio || !data_fim) return "Informe a data inicial e a data final.";
  if (!dataValida(data_inicio) || !dataValida(data_fim)) return "Período inválido.";
  if (data_inicio > data_fim) return "A data inicial deve ser anterior ou igual à data final.";
  return null;
};

export const formatarDataBR = (valor: string) =>
  dayjs(valor).format("DD/MM/YYYY");
